import React from 'react';
import {render} from 'react-dom';
require('./main.css');
import HomePage from './HomePage';
import AboutPage from './AboutPage';
import OurTeamPage from './OurTeamPage';
import ServicesPage from './ServicesPage';
import ClientsPage from './ClientsPage';
import NewsCentre from './NewsCentre';
import ContactPage from './ContactPage';
import {
  BrowserRouter as Router,
  Route,
  withRouter
} from 'react-router-dom';
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}
ScrollToTop = withRouter(ScrollToTop);

const App = () => (
  <Router>
    <ScrollToTop>
      <div>
        <Route exact path="/" component={HomePage}/>
        <Route path="/about" component={AboutPage}/>
        <Route path="/team" component={OurTeamPage}/>
        <Route path="/services" component={ServicesPage}/>
        <Route path="/newsCentre" component={NewsCentre}/>
        <Route path="/contact" component={ContactPage}/>
      </div>
    </ScrollToTop>
  </Router>
);


render(<App/>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js